// Creates a sorting predicate to sort for some property
const byProp = (propSelector) => (a, b) => {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
    const aProp = propSelector(a);
    const bProp = propSelector(b);

    if (aProp < bProp) {
        return -1;
    }

    if (aProp > bProp) {
        return 1;
    }

    return 0;
};

export default byProp;
